import { render, staticRenderFns } from "./ClassBodyText.vue?vue&type=template&id=632a1c16&scoped=true&"
import script from "./ClassBodyText.vue?vue&type=script&lang=js&"
export * from "./ClassBodyText.vue?vue&type=script&lang=js&"
import style0 from "./ClassBodyText.vue?vue&type=style&index=0&id=632a1c16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a1c16",
  null
  
)

export default component.exports